"use client";
import { Button } from "@/components/ui/button";
import { useViewMode } from "@/context/ViewModeContext";
import ArrowLongLeftIcon from "@heroicons/react/24/solid/ArrowLongLeftIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";

export default function MapHeader({ backButtonTitle }: { backButtonTitle: string }) {
  const {setViewMode} = useViewMode();

  return null
  // return (
  //   <div className="container flex justify-between items-center py-2">
  //     <Button className="!h-6" onClick={() => setViewMode('list')} variant="assistant" size="sm">
  //       <ArrowLongLeftIcon className="size-5" />
  //        {backButtonTitle}
  //     </Button>

  //     <button
  //       onClick={() => setViewMode('list')}
  //       className="flex gap-2 font-bold items-center text-sm text-gray-400"
  //     >
  //       Kapat
  //       <XMarkIcon className="size-8" />
  //     </button>
  //   </div>
  // );
}